import React, { useEffect,useRef } from "react";
import PropTypes from "prop-types";
import Highcharts from "highcharts";
import {  CaloriesChallengeIcon, MilesChallengeIcon, StepIcon } from "../../utils/icons";


const DailyProgressGraph = ({ value, max , ActivityType}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    Highcharts.chart(chartRef.current, {
      chart: {
        type: 'solidgauge',
        // renderTo: id,
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },

      title: null,

      credits: {
        enabled: false
      },

      tooltip: {
        enabled: false
      },

      pane: {
        startAngle: -159.9,
        endAngle: 159.9,
        background: [{
          outerRadius: '112%',
          innerRadius: '93%',
          backgroundColor: (ActivityType === "steps" ?  'rgba(252, 242, 243, 1)' :  "rgba(239, 239, 239, 1)" ) || Highcharts.Color(Highcharts.getOptions().colors[0])
            .setOpacity(0.3)
            .get(),
          borderWidth: 0,
          shape: "arc"
        }],
      },
 
      yAxis: {
        min: 0,
        max: max,
        lineWidth: 0,
        tickPositions: []
      },
 
      plotOptions: {
        solidgauge: {
          rounded: true,
          // linecap: 'round',
          dataLabels: {
            enabled: false
          },
          stickyTracking: false,
          // rounded: parseFloat(payload.percent_calories) > 0
        }
      },
 
      series: [{
        name: 'Total',
        data: [{
          color: ActivityType === "steps" ? '#DA6C74' : ActivityType === "miles" ? '#DA9B6C' : '#75B084',
          radius: '112%',
          innerRadius: '93%',
          // y: value,
          y: value === 0 ? 0.0001 : value
        }],
      }]
    });
    
    
  }, [value, max]);

  return (
    <div style={{ position: "relative", width: 160 }}>
      <div ref={chartRef} />

      {/* Center Icon */}
      <div
        style={{
          position: "absolute",
          top: "51%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {ActivityType === "steps" ? StepIcon() : ActivityType === "miles" ? MilesChallengeIcon() : CaloriesChallengeIcon()  }
      </div>
    </div>
  );
};



DailyProgressGraph.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  selectedDate: PropTypes.string.isRequired,
  challengeDetails: PropTypes.object.isRequired,
  ActivityType: PropTypes.string.isRequired,
};


export default DailyProgressGraph;
